import BoardShow from "./show";


if (document.body.getAttribute("data-current-path") === "ticket/boards") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "show") {
        new BoardShow()
    }
}